var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[(_vm.isHistoryVisible)?_c('feature-card-basic',{ref:"featureCard",attrs:{"layer":_vm.layer,"object-extras-tabs":['notes'],"icons-to-show":['showNotes'],"hide-dots-items":"","hide-feature-watcher":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }